// Shipping API (phase 6) — staff only.
import { api } from './client.js';

export const fetchOrderShipping = (orderId) => api.get(`/shipping/orders/${orderId}`).then((r) => r.data);
export const resolveShipping = (orderId) => api.post(`/shipping/orders/${orderId}/resolve`).then((r) => r.data);
export const setDestination = (orderId, country) => api.post(`/shipping/orders/${orderId}/destination`, { country }).then((r) => r.data);
export const setIncoterm = (orderId, incoterm) => api.post(`/shipping/orders/${orderId}/incoterm`, { incoterm }).then((r) => r.data);
export const quoteShipping = (orderId) => api.post(`/shipping/orders/${orderId}/quote`).then((r) => r.data);
export const confirmShipping = (orderId, body) => api.post(`/shipping/orders/${orderId}/confirm`, body).then((r) => r.data);
export const reconcileShipping = (orderId) => api.post(`/shipping/orders/${orderId}/reconcile`).then((r) => r.data);
